module.exports = __webpack_public_path__ + "media/images/seta-azul-baixo-f12aae8dd82dc7f2de447861f81601c4.svg";